import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import Logo from '../images/LOGO.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerStyles = {
    footer: {
      backgroundColor: '#0F172A',
      color: 'white',
      padding: '4rem 1.5rem 2rem',
      borderTop: '1px solid #1E293B'
    },
    container: {
      maxWidth: '1280px',
      margin: '0 auto'
    },
    topSection: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '3rem',
      marginBottom: '3rem'
    },
    logoSection: {
      maxWidth: '400px'
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      marginBottom: '1.5rem'
    },
    logoIcon: {
      width: '48px',
      height: '48px',
      backgroundColor: '#14b8a6',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      fontWeight: 'bold',
      color: 'white'
    },
    logoText: {
      display: 'flex',
      flexDirection: 'column'
    },
    logoTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: 'white',
      marginBottom: '0.25rem'
    },
    logoSubtitle: {
      fontSize: '14px',
      color: '#64748B'
    },
    description: {
      color: '#94A3B8',
      fontSize: '14px',
      lineHeight: '1.6',
      marginBottom: '1.5rem'
    },
    mission: {
      color: '#64748B',
      fontSize: '13px',
      fontStyle: 'italic',
      marginBottom: '1.5rem'
    },
    socialLinks: {
      display: 'flex',
      gap: '1rem'
    },
    socialLink: {
      width: '40px',
      height: '40px',
      backgroundColor: '#1E293B',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#64748B',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      border: '1px solid #334155'
    },
    section: {
      marginBottom: '1rem'
    },
    sectionTitle: {
      fontSize: '1.125rem',
      fontWeight: '600',
      color: 'white',
      marginBottom: '1.5rem'
    },
    linkList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem'
    },
    link: {
      color: '#94A3B8',
      fontSize: '14px',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
      cursor: 'pointer'
    },
    contactInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      color: '#94A3B8',
      fontSize: '14px'
    },
    contactIcon: {
      width: '20px',
      height: '20px',
      color: '#14b8a6'
    },
    bottomSection: {
      borderTop: '1px solid #1E293B',
      paddingTop: '2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '1rem'
    },
    copyright: {
      color: '#64748B',
      fontSize: '14px'
    },
    bottomLinks: {
      display: 'flex',
      gap: '2rem',
      flexWrap: 'wrap'
    },
    bottomLink: {
      color: '#94A3B8',
      fontSize: '14px',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
      cursor: 'pointer'
    }
  };

  return (
    <footer style={footerStyles.footer}>
      <div style={footerStyles.container}>
        {/* Top Section */}
        <div style={footerStyles.topSection}>
          {/* Logo and About Section */}
          <div style={footerStyles.logoSection}>
            <div style={footerStyles.logo}>
              <a href='/'>
                <img src={Logo} alt="Logo" style={{ height: '150px', borderRadius: '100%' }} />
              </a>
            </div>
            <p style={footerStyles.description}>
              Empowering the next generation through accessible AI education, certification 
              programs, and hands-on learning experiences that bridge the gap between 
              academia and industry.
            </p>
            <p style={footerStyles.mission}>
              Mission Statement
            </p>
            <div style={footerStyles.socialLinks}>
              <a 
                href="#" 
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#14b8a6';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#1E293B';
                  e.target.style.color = '#64748B';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                <Facebook size={20} />
              </a>
              <a 
                href="#" 
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#14b8a6';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#1E293B';
                  e.target.style.color = '#64748B';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                <Twitter size={20} />
              </a>
              <a 
                href="#" 
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#14b8a6';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#1E293B';
                  e.target.style.color = '#64748B';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="#" 
                style={footerStyles.socialLink}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#14b8a6';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#1E293B';
                  e.target.style.color = '#64748B';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Programs Section */}
          <div style={footerStyles.section}>
            <h3 style={footerStyles.sectionTitle}>Programs</h3>
            <div style={footerStyles.linkList}>
              <a 
                href="/student-membership" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Student Memberships
              </a>
              <a 
                href="/programs" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                AI Certifications
              </a>
              <a 
                href="/workshop-bootcamp" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Workshops & Bootcamps
              </a>
              <a 
                href="/ai-internship-program" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Internship Program
              </a>
              <a 
                href="/research" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Research Opportunities
              </a>
            </div>
          </div>

          {/* Partnerships Section */}
          <div style={footerStyles.section}>
            <h3 style={footerStyles.sectionTitle}>Partnerships</h3>
            <div style={footerStyles.linkList}>
              <a 
                href="/institutional-partnerships" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Institutional Partnerships
              </a>
              <a 
                href="/industrial-visit-program" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Industry Visits
              </a>
              <a 
                href="/ai-training-kit-program" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Trainer Kit Program
              </a>
              <a 
                href="/corporate-partnership" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Corporate Partnerships
              </a>
              <a 
                href="/become-partner" 
                style={footerStyles.link}
                onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
                onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
              >
                Become a Partner
              </a>
            </div>
          </div>

          {/* Contact Section */}
          <div style={footerStyles.section}>
            <h3 style={footerStyles.sectionTitle}>Connect</h3>
            <div style={footerStyles.contactInfo}>
              <div style={footerStyles.contactItem}>
                <Mail style={footerStyles.contactIcon} />
                <a 
                  href="mailto:info@globalaisociety.org" 
                  style={{...footerStyles.link, color: '#14b8a6'}}
                  onMouseEnter={(e) => e.target.style.color = '#0f9c8e'}
                  onMouseLeave={(e) => e.target.style.color = '#14b8a6'}
                >
                  info@globalaisociety.com
                </a>
              </div>
              <div style={footerStyles.contactItem}>
                <Phone style={footerStyles.contactIcon} />
                <a 
                  href="tel:+15551234567" 
                  style={{...footerStyles.link, color: '#14b8a6'}}
                  onMouseEnter={(e) => e.target.style.color = '#0f9c8e'}
                  onMouseLeave={(e) => e.target.style.color = '#14b8a6'}
                >
                  +91 99000 01511
                </a>
              </div>
              <div style={footerStyles.contactItem}>
                <MapPin style={footerStyles.contactIcon} />
                <span style={footerStyles.link}>
                  No. 261, 9th A Main, Jayanagar<br />
                  Bengaluru, Karnataka 560011, India
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={footerStyles.bottomSection}>
          <div style={footerStyles.copyright}>
            © {currentYear} Global AI Society. All Rights Reserved.
          </div>
          <div style={footerStyles.bottomLinks}>
            <a 
              href="/privacy-policy" 
              style={footerStyles.bottomLink}
              onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
              onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
            >
              Privacy Policy
            </a>
            <a 
              href="/contact-us" 
              style={footerStyles.bottomLink}
              onMouseEnter={(e) => e.target.style.color = '#14b8a6'}
              onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;